import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { ListResponse, PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import { OptionType } from "commons/ui/input/Select";

import { AdvancedListRequest } from "types/api/commons";

import { ShowroomBody, ShowroomDetails, ShowroomListItem } from "types/api/showroom";

function useShowroomApi() {
    const { get, del, post, put } = useHttpManaged();
    const getAllShowroom = React.useCallback((queryParams: AdvancedListRequest, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ListResponse<ShowroomListItem>> => {
        return get<undefined, AdvancedListRequest, ListResponse<ShowroomListItem>>({
            url: "/showroom",
            queryParams: queryParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const getOneShowroom = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ShowroomDetails> => {
        return get<PathParamsWithId, undefined, ShowroomDetails>({
            url: "/showroom/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const createShowroom = React.useCallback((body: ShowroomBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ResponseWithId> => {
        return post<undefined, undefined, ShowroomBody, ResponseWithId>({
            url: "/showroom",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const updateShowroom = React.useCallback((pathParams: PathParamsWithId, body: ShowroomBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return put<PathParamsWithId, undefined, ShowroomBody, null>({
            url: "/showroom/:id",
            pathParams: pathParams,
            body: body,
            options: options,
            headers: headers
        });
    }, [put]);
    const getAllGroups = React.useCallback((options?: OptionsType, headers?: { [x: string]: string }): ResponseType<OptionType[]> => {
        return get<undefined, undefined, OptionType[]>({
            url: "/showroom-group",
            options: options,
            headers: headers
        });
    }, [get]);
    const deleteShowroom = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/showroom/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getAllShowroom,
        getOneShowroom,
        createShowroom,
        updateShowroom,
        getAllGroups,
        deleteShowroom
    };
}

export default useShowroomApi;